export const GRAPHQL_ENDPOINT = process.env.REACT_APP_GRAPHQL_API_URL ?? ''

export const SHOPIFY_STOREFRONT_ACCESS_TOKEN =
  process.env.REACT_APP_X_SHOPIFY_STOREFRONT_ACCESS_TOKEN ?? ''

export const VERIFY_EMAIL_URL = process.env
  .REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL
  ? `${process.env.REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL}account/verify-email`
  : ''

export const ACCOUNT_URL = process.env
  .REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL
  ? `${process.env.REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL}account/contact-information`
  : ''

export const AUTH_SESSION_URL = process.env
  .REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL
  ? `${process.env.REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL}auth/session`
  : ''

export const AUTH_TOKEN_URL = process.env
  .REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL
  ? `${process.env.REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL}auth/token`
  : ''

export const SHOPIFY_GRAPHQL_URL =
  process.env.REACT_APP_X_SHOPIFY_GRAPHQL_URL ?? ''

export const PAYMENT_TOKENIZE_API =
  process.env.REACT_APP_PAYMENT_TOKENIZE_API ?? ''

export const PAYMENT_METHOD_API = process.env
  .REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL
  ? `${process.env.REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL}account/payment-methods`
  : ''

export const CLIENT_INFO_API = process.env
  .REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL
  ? `${process.env.REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL}account`
  : ''

export const BOOKED_APPOINTMENT = process.env
  .REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL
  ? `${process.env.REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL}account/appointments`
  : ''

export const SIGN_MEMBERSHIP_AGREEMENT_API = process.env
  .REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL
  ? `${process.env.REACT_APP_X_SHOPIFY_MIDDLEWARE_API_BASEURL}account/membership-agreement`
  : ''

export const EVENT_HORIZON_API = process.env.REACT_APP_EVENT_HORIZON_API ?? ''
export const SKOS_HORIZON_EVENTS = `${EVENT_HORIZON_API}/skincareos`

export const KLAVIYO_API_BASE_URL = 'https://a.klaviyo.com/client/'
export const SMS_SUBSCRIPTION_KLAVIYO_API = `${process.env.REACT_APP_KLAVIYO_API_BASE_URL}${process.env.REACT_APP_KLAVIYO_APP_ID}`
export const CREATE_EVENTS = 'events/?company_id='

export const REFERRAL_API_URL = process.env.REACT_APP_REFERRAL_API_URL ?? ''
export const REFERRAL_API_KEY = process.env.REACT_APP_REFERRAL_API_KEY ?? ''
export const REFERRAL_HMAC_SECRET =
  process.env.REACT_APP_REFERRAL_HMAC_SECRET ?? ''
